/**
 * What a line of the ficha is, in the pharmacy's words.
 *
 * Mirrors `INGREDIENT_KINDS` in `@rp/core`, which the web app cannot import;
 * the test beside this file reads that list from the source, so a kind added
 * there and not named here fails instead of printing its English key.
 */
export const LINE_KIND: Readonly<Record<string, string>> = {
  active: 'composição',
  derived: 'derivada',
  'capsule-shell': 'cápsula',
  packaging: 'embalagem',
  homeopathic: 'homeopático',
  excipient: 'excipiente',
  associated: 'associado',
  vehicle: 'veículo',
  other: 'outro',
}

/**
 * The words for one line's type.
 *
 * `other` is a letter the ERP used and we do not translate, so the letter is
 * printed beside it: seeing it on a real ficha is how each one was learnt. A
 * line with a letter and no kind is a conferência stored before its letter
 * had one, and reads the same way it did then.
 */
export function lineKind(line: {
  kind?: string | undefined
  kindCode?: string | undefined
}): string {
  const letter = line.kindCode === undefined ? undefined : `tipo ${line.kindCode}`
  if (line.kind === 'other') return letter === undefined ? LINE_KIND.other! : `outro · ${letter}`
  return LINE_KIND[line.kind ?? ''] ?? line.kind ?? letter ?? '—'
}
